module.exports = __webpack_public_path__ + "static/media/bordered-triangle-left-yellow.fc24c269.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/bordered-triangle-left-yellow.svg
// module id = 1841
// module chunks = 0